import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Banner } from 'src/@vymo/ui/blocks';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import { Widget } from 'src/@vymo/ui/molecules';
import classnames from 'classnames';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import TileActionHandler from './actions/tileActionHandler';
import {
  getSelectedTileData,
  getSpgWidgetDataForCode,
  getWidgetData,
} from './selector';
import { fetchTileAction } from './thunk';
import TileViewRenderer from './tile/tileView';
import { SelectedTileData } from './types';
import styles from './index.module.scss';

function SPGWidget({ widgetCode }) {
  const dispatch = useAppDispatch();
  const { isLoading, isTileActionLoading, tileActionError } = useAppSelector(
    (state) => getWidgetData(state, widgetCode),
  ) ?? {
    isLoading: false,
    isTileActionLoading: false,
    tileActionError: '',
  };

  const widgetDataForCode = useAppSelector((state) =>
    getSpgWidgetDataForCode(state, widgetCode),
  );

  const selectedTileData = useAppSelector((state) =>
    getSelectedTileData(state, widgetCode),
  ) as SelectedTileData;

  const [tileIndeClicked, setTileIndexClicked] = useState(-1);

  useEffect(() => {
    if (!isTileActionLoading) setTileIndexClicked(-1);
  }, [isTileActionLoading]);

  const onClickTileHandler = (tile, tileIndex) => {
    setTileIndexClicked(tileIndex);
    dispatch(fetchTileAction({ widgetCode, tile }));
  };

  if (widgetDataForCode?.data?.items?.length === 0) {
    return null;
  }

  return isLoading ? (
    <SkeletonLoader lines={4} />
  ) : (
    <>
      {_.isEmpty(selectedTileData) && tileActionError && (
        <Banner
          position="topRight"
          closeable
          message={tileActionError ?? ''}
          variant="error"
          duration={3000}
        />
      )}
      <Widget
        title={widgetDataForCode?.data?.name}
        content={
          <>
            <div
              className={classnames(
                styles.spg__tiles__container,
                'spg__tiles__jc',
              )}
            >
              {widgetDataForCode?.data?.items?.map((item, tileIndex) => (
                <TileViewRenderer
                  viewType={widgetDataForCode?.data?.viewType}
                  index={tileIndex}
                  isLoading={tileIndex === tileIndeClicked}
                  data={item}
                  onClick={onClickTileHandler}
                />
              ))}
            </div>
            {!_.isEmpty(selectedTileData) && (
              <TileActionHandler
                action={selectedTileData?.data?.action}
                error={tileActionError}
                widgetCode={widgetCode}
              />
            )}
          </>
        }
      />
    </>
  );
}

export default SPGWidget;
